import React, { useState } from 'react'
import { useParams } from 'react-router-dom';

const WorkWithUs = () => {
	const { role } = useParams("role");

	const [activeDropdown, setActiveDropdown] = useState(role ? role : "Research Fellows");
	const [currRole, setCurrRole] = useState(role ? role : "All");
	const [filter, setFilter] = useState(false);

	const roles = ["All", "Research Fellows", "Project Interns", "Staff"];

	const researchFellowData = [
		{
			title: "Post-doctoral Fellow: RF-Microwave",
			posted_on: "04 April, 2025",
			closes_on: "25 April, 2025",
			location: "Gandhinagar",
			role: "Research Fellows",
			pdfLink:"/pdf/Post-doctoral-Advertisement-for-SELC.pdf",
		},
		{
			title: "Research Fellow: RF-Microwave",
			posted_on: "04 April, 2025",
			closes_on: "25 April, 2025",
			location: "Gandhinagar",
			role: "Research Fellows",
			pdfLink:"/pdf/RF_Advertisement-for-SELC.pdf",
		},
		{
			title: "Research Fellow: Mathematics/Physics/Computer Science",
			posted_on: "28 March 2025",
			closes_on: "09 April, 2025",
			location: "Gandhinagar",
			role: "Research Fellows"
		},
		{
			title: "JRF Position Open on a Smart Energy Learning Centre Project",
			posted_on: "26 March 2025",
			closes_on: "06 April, 2025",
			location: "Gandhinagar",
			role: "Research Fellows",
			pdfLink:"/pdf/SELC_advertisement_project10.pdf",
		},
		{
			title: "Research fellow : SELC project A-14 advertisement",
			posted_on: "25 March 2025",
			closes_on: "30 April, 2025",
			location: "Gandhinagar",
			role: "Research Fellows",
			pdfLink:"/pdf/RF-Opening-Advertisement-SELC_25-A14(1).pdf",
		},
		{
			title: "Research Fellow: Machine Learning/ Deep Learning/ NLP",
			posted_on: "19 March 2025",
			closes_on: "31 March, 2025",
			location: "Gandhinagar",
			role: "Research Fellows",
			pdfLink:"/pdf/RF-Opening-Advertisement-SELC_25.pdf",
		},
		{
			title: "Research Fellow position for Forecasting with Deep Learning models",
			posted_on: "27 August, 2024",
			closes_on: "20 September, 2024",
			location: "Gandhinagar",
			role: "Research Fellows",
			pdfLink:"/pdf/RF-Opening-Advertisement-SELC_25.pdf",
		},
		{
			title: "Join Our Team - Junior Research Fellow (4 openings)",
			posted_on: "19 August, 2024",
			closes_on: "Untill Filled",
			location: "Gandhinagar",
			role: "Research Fellows",
			pdfLink:"/pdf/SELC-Requirement.pdf",
		}
	]

	const jobs = researchFellowData.filter(filterRole);

	function filterRole(jobs) {
		if (jobs.role === currRole || currRole === "All") {
			return jobs;
		}
	}

	// Function to handle opening PDF in a new tab
	const handleOpenPdf = (pdfLink) => {
		if (pdfLink) {
			// Open the PDF in a new tab
			window.open(pdfLink, '_blank');
		}
	};

	return (
		<div className="w-full font-Open-sans pt-28">
			<div className="flex flex-col items-start md:items-center max-w-6xl mx-auto w-full pt-16 pb-4 px-4 lg:px-0">
				<ul className="hidden md:flex items-center justify-center flex-wrap gap-4 md:gap-y-2">
					{roles.map((des, i) => (
						<li
							key={i}
							onClick={() => setCurrRole(des)}
							className={`p-2 px-4 text-lg font-medium font-Inter rounded-lg transition-colors duration-300 cursor-pointer hover:bg-primary-200 ${currRole === des ? "bg-primary-200 text-primary-800" : ""} `}
						>
							{des}
						</li>
					))}
				</ul>
				<div className="w-full relative md:hidden block">
					<div
						className="flex items-center justify-between border pr-4 rounded-xl overflow-hidden border-primary-600"
						onClick={() => setFilter(!filter)}
					>
						<p className="border-r border-primary-600 w-[89%] px-3 py-2">{currRole}</p>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width={16}
							height={16}
							fill="currentColor"
							className=""
							viewBox="0 0 16 16"
						>
							<path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z" />
						</svg>
					</div>
					<div className={"w-full absolute top-11 p-3 bg-transparent backdrop-blur-lg rounded-xl border border-black flex flex-col gap-3 z-10 origin-top transition-all duration-300 " + (filter ? "scale-y-100 opacity-100" : "scale-y-0 opacity-0")}>
						{roles.map((des, i) => (
							<p
								key={i}
								onClick={() => {
									setCurrRole(des)
									setFilter(!filter)
								}}
							>
								{des}
							</p>
						))}
					</div>
				</div>
				<h1 className="text-4xl leading-tight sm:leading-normal sm:text-5xl font-bold mt-7 mb-10 md:mb-14 relative "></h1>
				
				{jobs.length > 0 ? (
					jobs.map((item, idx) => {
						return (
							<div
								className={`w-full border-t border-gray-400 first:border-0 py-4 md:px-3 ${item.pdfLink ? 'cursor-pointer' : ''}`}
								key={idx}
								onClick={() => item.pdfLink && handleOpenPdf(item.pdfLink)}
							>
								<h2 className={`md:text-2xl text-sm text-justify md:text-left transition-all duration-300 ${item.pdfLink ? 'hover:text-primary-700 cursor-pointer' : ''}`}>
									{item.title}
									{item.pdfLink && (
										<span className="ml-2 text-primary-600 text-sm">(View PDF)</span>
									)}
								</h2>
								<div className="w-full text-sm md:mt-4 mt-3 flex md:flex-row flex-col md:items-center items-start justify-between lg:gap-4 gap-1">
									<p className="font-medium text-primary-600 flex items-center gap-1">Posted :<span className="text-black font-normal">{item.posted_on}</span></p>
									<p className="font-medium text-primary-600 flex items-center gap-1">Closes :<span className="text-black font-normal">{item.closes_on}</span></p>
									<p className="font-medium text-primary-600 flex items-center gap-1">Location :<span className="text-black font-normal">{item.location}</span></p>
								</div>
							</div>
						)
					})
				) : (
					<div className="w-full py-8 text-center">
						<div className="bg-gray-100 rounded-lg p-6 shadow-sm">
							<h3 className="text-xl font-medium text-gray-700">No job openings available</h3>
							<p className="mt-2 text-gray-600">There are currently no job openings for {currRole === "All" ? "any roles" : currRole}.</p>
							<p className="mt-4 text-primary-600">Please check back later or try selecting a different category.</p>
						</div>
					</div>
				)}
			</div>
		</div>
	)
}

export default WorkWithUs